import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";

export type IconStatProps = {
  icon: React.ReactNode;
  label: string;
  value: string;
};

const IconStat: React.FC<IconStatProps> = ({ icon, label, value }) => {
  return (
    <Flex
      gap={{ base: 2, md: 3 }}
      align="flex-start"
      p={{ base: 2, sm: 3 }}
      borderRadius="12px"
      bg="#fbf8f8"
      borderWidth="1px"
      borderColor="#efe6e6"
    >
      <Box mt="2px" color="#4A2C2A">
        {icon}
      </Box>
      <Box minW={0}>
        <Text fontSize="11px" fontWeight="700" letterSpacing="0.08em" color="#8a7b7b" textTransform="uppercase">
          {label}
        </Text>
        <Text mt="2px" fontSize="14px" fontWeight="700" color="#2b1b1a" wordBreak="break-word">
          {value}
        </Text>
      </Box>
    </Flex>
  );
};

export default IconStat;
